$(document).on("pubgm_mainsite_introduce rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
   
});